import { CheckIcon } from '@/components/Icons';
import { textInputVariant } from '@/components/TextInput/textInputVariant';
import cn from '@/utils/cn';
import { VariantProps } from 'class-variance-authority';
import React, { ChangeEvent, HTMLAttributes, useEffect, useRef } from 'react';

interface NoteInputProps
  extends HTMLAttributes<HTMLInputElement>,
    VariantProps<typeof textInputVariant> {
  value?: string;
  onTextChange: (e: ChangeEvent<HTMLInputElement>) => void;
  isSaved: boolean;
}

const NoteInput: React.FC<NoteInputProps> = ({
  value,
  onTextChange,
  isSaved,
  variant,
  className
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (isSaved) {
      inputRef.current?.blur();
    }
  }, [isSaved]);

  return (
    <div className="relative">
      <input
        ref={inputRef}
        type="text"
        placeholder="Note here"
        value={value}
        onChange={onTextChange}
        className={cn(textInputVariant({ variant, className }))}
      />

      {isSaved && (
        <span className="text-emerge-teal absolute end-px bottom">
          <span className="flex flex-row items-center">
            <p className="text-sm px-2">Saved</p> <CheckIcon size="xs" />
          </span>
        </span>
      )}
    </div>
  );
};

export default NoteInput;
